import React, { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import {
    IconButton,
    InputAdornment,
    Stack,
    StandardTextFieldProps,
    TextField,
} from '@mui/material';

import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';

export interface ControlledTextPasswordFieldProps
    extends StandardTextFieldProps {
    control: Control<any>;
    hideControl?: boolean;
}

export function ControlledTextPasswordFieldFilled({
                                                      label, hideControl,
                                                      ...props
                                                  }: ControlledTextPasswordFieldProps) {

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isFocused, setFocused] = useState<boolean>(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const handleFocus = () => setFocused(true);

    const handleBlur = () => setFocused(false);

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Stack sx={{ width: '100%' }}>
                    <TextField
                        {...props}
                        label={label}
                        variant="filled"
                        size="small"
                        type={showPassword ? 'text' : 'password'}
                        value={value}
                        onChange={onChange}
                        error={!!error}
                        defaultValue={props.defaultValue}
                        helperText={error ? error.message : null}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        InputProps={hideControl ? { disableUnderline: true, ...props.InputProps } : {
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClickShowPassword} edge="end">
                                        {showPassword ? (
                                            <VisibilityRoundedIcon />
                                        ) : (
                                            <VisibilityOffRoundedIcon />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            ),
                            ...props.InputProps,
                        }}
                        InputLabelProps={{
                            shrink: isFocused || !!value,
                            ...props.InputLabelProps,
                        }}
                    ></TextField>
                </Stack>
            )}
        />
    );
}














